<template>
  <cv-dropdown class="ff-dropdown" v-bind="$attrs" v-on="inputListeners">
    <cv-dropdown-item class="ff-dropdown__item" :key="index" v-for="(item, index) in items" :value="item.value">{{item.title}}</cv-dropdown-item>
  </cv-dropdown>
</template>

<script>
export default {
  name: 'ff-input',
  props: [
    'items',
    'action'
  ],
  data () {
    return {
    }
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  computed: {
    inputListeners () {
      return {
        ...this.$listeners,
        change: (e) => {
          if (e === this.$attrs.value) return
          this.$emit('change', e)
          if (!this.action) return
          return this.action()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-dropdown {
    font-size: $fontSize-normal;
    margin-bottom: $unit-1;
  }

  ::v-deep .bx--dropdown {
    @include input-reset;
    background: $color-white;
    border-radius: $borderRadius;
    // @include input-container;
  }

  ::v-deep .bx--dropdown-text__inner {
    font-size: $fontSize-normal;
  }

  ::v-deep .bx--dropdown-text {
    @include input-container(pointer);
  }

  ::v-deep .bx--dropdown-link {
    font-size: $fontSize-normal;
  }

</style>
